module.exports = __webpack_public_path__ + "static/media/hero-vbn.fb1d4ebd.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-vbn.webp
// module id = 205
// module chunks = 51